module.exports = __webpack_public_path__ + "media/images/icon__community@3x-ef949c878c6d466af5b8a6eb820bb299.png";